export class LineType {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default LineType;